import { render, staticRenderFns } from "./NavbarBridgeSwift.vue?vue&type=template&id=7272a479&lang=pug"
import script from "./NavbarBridgeSwift.vue?vue&type=script&lang=js"
export * from "./NavbarBridgeSwift.vue?vue&type=script&lang=js"
import style0 from "./NavbarBridgeSwift.vue?vue&type=style&index=0&id=7272a479&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports